<template>
  <div class="uk-grid-medium" uk-grid>
    <div class="uk-width-5-5">
      <div class="d-flex">
        <nav id="breadcrumbs" class="mb-3">
          <ul>
            <li>
              <a href="#"> <i class="uil-home-alt"></i> </a>
            </li>
            <li>{{ $t("survey.surveys") }}</li>
            <li>{{ isEditMode ? $t("survey.edit") : $t("survey.add") }}</li>
          </ul>
        </nav>
      </div>

      <template v-for="(error, index) in errorMessages">
        <div v-if="error != null" :key="'error-' + index" class="uk-alert uk-alert-danger" style="position: relative;">
          <button
              class="uk-alert-close"
              style="cursor: pointer; border: none; background: transparent; opacity: 0.4;"
              type="button"
              @click.stop.prevent="removeError(index)">
            ×
          </button>
          <p style="color: red; margin: 0; padding-right: 30px;">
            <i class="uil-exclamation-triangle"></i> {{ error }}
          </p>
        </div>
      </template>

      <div class="card position-relative p-0">
        <div class="card-body">

          <!-- Tabs - Sadece Add modunda göster -->
          <ul v-if="!isEditMode" id="userAddOptions" class="uk-tab page-tab" uk-switcher="animation: uk-animation-fade">
            <li>
              <a id="add_from_manuel" href="#">
                <h4>
                  <i class="uil-user-plus"/> {{ $t('general.add_survey_question') }}
                </h4>
              </a>
            </li>
            <li>
              <a id="add_from_excel" href="#">
                <h4><i class="uil-table"></i> {{ $t("users.add_to_excel") }}</h4>
              </a>
            </li>
          </ul>

          <ul :class="{ 'no-switcher': isEditMode }" class="uk-switcher">
            <li :class="{ 'uk-active': isEditMode }">

              <div class="mt-4 position-relative">

                <div v-if="loading"
                     style="position: absolute; height: 100%; width: 100%; z-index: 999; background: rgba(238, 238, 238, 0.5); display: flex; justify-content: center; align-items: center">
                  <div class="text-info" uk-spinner="ratio: 4"></div>
                </div>

                <div class="card-body">
                  <h4>
                    <i class="uil-question-circle"></i>
                    {{ isEditMode ? $t("survey.edit") : $t("survey.add") }}
                  </h4>
                  <hr/>
                  <div class="row">
                    <div class="col-xl-9 m-auto">
                      <form action="" novalidate="novalidate">
                        <div class="form-group row mb-3 align-items-center">
                          <label class="col-md-3 col-form-label" for="course_title">
                            {{ $t("survey.name") }} <span class="required">*</span>
                          </label>
                          <div class="col-md-9">
                            <input id="course_title" v-model="name" class="form-control mb-0" name="title"
                                   required="" type="text"/>
                          </div>
                        </div>

                        <div v-if="!isEditMode" class="form-group row mb-3">
                          <label class="col-md-3 col-form-label" for="passmark">
                            {{ $t("survey.point") }} (0-100)<span class="required">*</span>
                          </label>
                          <div class="col-md-9">
                            <input id="passmark" v-model="point" :placeholder="$t('survey.enter_point')"
                                   class="form-control" required="" type="text"/>
                          </div>
                        </div>

                        <div v-if="!isEditMode" class="d-flex justify-content-end align-items-center">
                          <toggle-button v-model="is_compulsory"
                                         :labels="{ checked: $t('survey.compulsory'), unchecked: $t('survey.not_compulsory') }"
                                         :sync="true" :width="140" color="#ae71ff"/>
                        </div>

                        <div v-if="isEditMode" class="d-flex justify-content-end align-items-center">
                          <toggle-button v-model="is_default" :labels="{ checked: $t('survey.default'), unchecked: $t('survey.not_default') }" :sync="true" :width="140"
                                         color="#ae71ff"/>
                        </div>

                        <div
                            class="d-flex align-content-center justify-content-end table-vertical-center align-items-center">
                          <toggle-button v-model="status_id"
                                         :labels="{ checked: $t('survey.active'), unchecked: $t('survey.inactive') }"
                                         :sync="true"
                                         :width="140" color="#ae71ff"/>
                        </div>

                        <div
                            class="d-flex align-content-center justify-content-end table-vertical-center align-items-center mt-2">
                          <span class="mr-2">
                            {{ $t('general.mail_notification') }}
                            <i class="uil-info-circle"
                               style="margin-left: 6px; cursor: pointer;"
                               :uk-tooltip="'title: ' + $t('general.survey_completion_manager_email_info')"></i>
                          </span>
                          <toggle-button v-model="send_completion_email"
                              :labels="{ checked: $t('general.yes'), unchecked: $t('general.no') }"
                              :sync="true"
                              :width="140"
                              color="#ae71ff"/>
                        </div>

                        <hr/>

                        <div class="questions-area">
                          <div v-for="(question, index) in questions" :key="'question_' + index" class="question-item">
                            <div class="d-flex justify-content-between">
                              <h4>{{ $t('survey.question') }} #{{ index + 1 }}</h4>
                              <button class="btn btn-outline-danger btn-sm" type="button"
                                      @click="deleteQuestion(index, question.id)">
                                <i class="uil-trash"></i> {{ $t("survey.delete_question") }}
                              </button>
                            </div>
                            <hr>
                            <div class="form-group row mb-3 align-items-center">
                              <label :for="'question_name_' + index" class="col-md-3 col-form-label">
                                {{ $t('survey.question_name') }} <span class="required">*</span>
                              </label>
                              <div class="col-md-9">
                                <input :id="'question_name_' + index" v-model="question.name"
                                       class="mb-0 form-control" type="text">
                              </div>
                            </div>
                            <div class="form-group row mb-3 align-items-center">
                              <label class="col-md-3 col-form-label">{{ $t('survey.question_type') }}</label>
                              <div class="col-md-9">
                                <span v-if="question.type === 1">{{ $t('general.multiple_choice') }}</span>
                                <span v-if="question.type === 2">{{ $t('survey.type_textarea') }}</span>
                              </div>
                            </div>

                            <div v-if="question.type === 1">
                              <hr>
                              <h5>{{ $t('survey.options') }}</h5>
                              <hr>
                              <div v-for="(option, optionIndex) in question.options" :key="'opt_' + optionIndex">
                                <div class="d-flex justify-content-start">
                                  <div class="p-2">
                                    <label style="font-size: 13px">{{ $t('survey.option_label') }} #{{
                                        optionIndex + 1
                                      }}</label>
                                    <input v-model="option.label" class="form-control mb-0" type="text">
                                  </div>
                                  <div class="p-2">
                                    <label style="font-size: 13px">{{ $t('survey.option_point') }} #{{
                                        optionIndex + 1
                                      }}</label>
                                    <select v-model="option.point" class="mb-0">
                                      <option v-for="n in question.options.length" :key="n" :value="n">{{ n }}</option>
                                    </select>
                                  </div>
                                  <div v-if="optionIndex > 1" class="p-2">
                                    <button class="uk-button uk-text-warning" style="margin-top: 1.8rem;"
                                            type="button" @click="deleteOption(optionIndex, index)">
                                      <i class="uil-trash"></i>
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <div class="p-2">
                                <button v-if="question.options.length < 5" class="uk-button uk-button-primary small"
                                        type="button" @click="addOption(index)">
                                  <i class="uil-plus m-0"></i>{{ $t('general.add_option') }}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="d-flex justify-content-between">
                          <select v-model="selected_question_type" class="mx-1" style="max-width: 200px;">
                            <option :value="1">{{ $t('general.multiple_choice') }}</option>
                            <option :value="2">{{ $t('survey.type_textarea') }}</option>
                          </select>
                          <input :value="$t('survey.add_question')" class="btn btn-lg btn-outline-primary" type="button"
                                 @click="addQuestion"/>
                        </div>

                        <hr>

                        <div class="uk-card-footer d-flex justify-content-end pb-0 pr-0 align-items-center">
                          <button class="uk-button uk-button-primary small" type="button" @click="saveForm">
                            <i class="icon-feather-arrow-right"></i> {{ isEditMode ? $t('general.update') : $t("general.save") }}
                          </button>
                          <button v-if="!isEditMode" :disabled="!$hasPermission('create_assignment')" :style="{ cursor: !$hasPermission('create_assignment') ? 'not-allowed' : 'pointer' }"
                                  class="uk-button uk-button-primary small"
                                  style="margin-left:5vh" type="button"
                                  @click="saveForm('assign_page')">
                            <i class="uil-location-arrow"></i>
                            {{ $t("general.save_and_assign") }}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </li>

            <!-- Excel upload tab - Sadece Add modunda -->
            <li v-if="!isEditMode">
              <survey-from-excel-uploader :sample-excel-endpoint="'/api/survey/sample-excel'"
                                          @imported="handleImportedExcelData"/>
            </li>
          </ul>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
import store from "@/core/services";
import module, {
  BASE_URL,
  MODULE_NAME,
  CREATE_ITEM,
  UPDATE_ITEM,
  GET_ITEM,
  DELETE_QUESTION,
  ITEM,
  LOADING,
  ERROR,
  SUCCESS
} from "@/core/services/store/survey.module";
import SurveyFromExcelUploader from "@/view/components/uploader/SurveyFromExcelUploader.vue";
import { showError, showSuccess } from "@/utils/alertUtils";

export default {
  name: "SurveyAddEdit",
  components: { SurveyFromExcelUploader },
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule)
      }
    }

    registerStoreModule(MODULE_NAME, module)
  },
  data() {
    return {
      errorMessages: [],
      selected_question_type: 1, // 1: dropdown, 2: textarea
      questions: [],
      name: null,
      status_id: true,
      is_compulsory: false,
      is_default: false,
      send_completion_email: false,
      point: 0,
    }
  },
  computed: {
    isEditMode() {
      return !!this.$route.params.id;
    },
    loading: {
      get() {
        return store.getters[MODULE_NAME + "/" + LOADING];
      },
      set(value) {
      },
    },
    surveyItem: {
      get() {
        return store.getters[MODULE_NAME + "/" + ITEM];
      },
      set(value) {
      },
    },
    error: {
      get() {
        return store.getters[MODULE_NAME + "/" + ERROR];
      },
      set(value) {
      },
    },
    success: {
      get() {
        return store.getters[MODULE_NAME + "/" + SUCCESS];
      },
      set(value) {
      },
    },
  },
  methods: {
    removeError(index) {
      this.errorMessages.splice(index, 1);
    },
    loadSurveyData() {
      if (this.isEditMode && this.surveyItem && this.surveyItem.id) {
        this.name = this.surveyItem.name;
        this.status_id = parseInt(this.surveyItem.status_id) === 1;
        this.is_default = parseInt(this.surveyItem.is_default) === 1;
        this.send_completion_email = this.surveyItem.send_completion_email === true
            || parseInt(this.surveyItem.send_completion_email) === 1;

        this.questions = [];
        if (this.surveyItem.questions && this.surveyItem.questions.length > 0) {
          this.surveyItem.questions.forEach(question => {
            this.questions.push({
              id: question.id,
              name: question.name,
              type: question.type,
              options: question.options && Array.isArray(question.options)
                  ? question.options
                  : JSON.parse(question.options)
            });
          });
        }
      }
    },
    handleImportedExcelData(datax) {
      this.questions = [];

      const importedQuestions = datax
          .filter(data => data)
          .map((data) => {
            const questionText = data[0];
            const questionTypeText = data[1];

            let questionType;
            if (questionTypeText === this.$t('general.multiple_choice')) {
              questionType = 1;
            } else if (questionTypeText === this.$t('evaluation_survey.type_textarea')) {
              questionType = 2;
            } else {
              console.warn("Unrecognized question type:", questionTypeText);
              return null;
            }

            if (questionType === 1) {
              const options = data.slice(2)
                  .filter(option => option !== null && option !== '')
                  .map((option, index) => ({
                    label: option.toString(),
                    point: index + 1
                  }));

              return options.length > 0 ? {
                name: questionText,
                type: questionType,
                options: options
              } : null;
            } else if (questionType === 2) {
              return {
                name: questionText,
                type: questionType,
                options: []
              };
            }

            return null;
          })
          .filter(question => question !== null);

      this.questions = [...this.questions, ...importedQuestions];

      if (this.questions.length === 0) {
        showError(this.$t('general.empty_or_incorrect_language_excel'))
        return
      }

      this.switchToFirstTab()
    },
    switchToFirstTab() {
      const element = document.getElementById('userAddOptions');
      if (element) {
        UIkit.switcher(element).show(0);
      }
    },
    deleteOption(optionIndex, questionIndex) {
      this.questions[questionIndex]['options'].splice(optionIndex, 1);
      // Puanları yeniden sırala (1'den başlayarak)
      this.questions[questionIndex]['options'].forEach((option, index) => {
        option.point = index + 1;
      });
    },
    addOption(questionIndex) {
      this.questions[questionIndex]['options'].push({
        label: null,
        point: this.questions[questionIndex]['options'].length + 1,
      })
    },
    validateForm() {
      this.resetMessages();
      let isValid = true;

      // Anket adı kontrolü
      if (this.name == null || this.name.length < 3) {
        this.errorMessages.push(
            this.$t("validation.required_field").replace(":NAME", this.$t("survey.name"))
        );
        isValid = false;
      }

      // Puan kontrolü (sadece add modunda)
      if (!this.isEditMode && (this.point == null || +this.point == 0 || +this.point > 100)) {
        this.errorMessages.push(
            this.$t("validation.required_field").replace(":NAME", this.$t("survey.point"))
        );
        isValid = false;
      }

      // En az bir soru olmalı
      if (this.questions.length === 0) {
        this.errorMessages.push(
            this.$t("validation.required_field").replace(":NAME", this.$t("survey.questions"))
        );
        isValid = false;
      }

      // Soru ve seçenek kontrolü
      this.questions.forEach(question => {
        if (question.name == null || question.name.trim() === '') {
          this.errorMessages.push(
              this.$t("validation.required_field").replace(":NAME", this.$t("survey.question_name"))
          );
          isValid = false;
        }
        
        // Çoktan seçmeli sorularda seçenek kontrolü
        if (question.type === 1) {
          question.options.forEach(option => {
            if (option.label == null || option.label.trim() === '') {
              this.errorMessages.push(
                  this.$t("validation.required_field").replace(":NAME", this.$t("survey.option_label"))
              );
              isValid = false;
            }
          });
        }
      });

      if (!isValid) {
        this.scrollToTop();
      }

      return isValid;
    },
    prepareQuestionsData() {
      let questions = [];
      this.questions.forEach(question => {
        let preparedQuestion = Object.assign({}, question);
        preparedQuestion.options = JSON.stringify(question.options);
        questions.push(preparedQuestion);
      });
      return questions;
    },
    saveForm(process_type) {
      let self = this;

      if (!this.validateForm()) {
        return;
      }

      let questions = this.prepareQuestionsData();

      if (self.isEditMode) {
        // Update existing survey
        store.dispatch(MODULE_NAME + "/" + UPDATE_ITEM, {
          url: BASE_URL + "/" + self.$route.params.id,
          contents: {
            name: self.name,
            status_id: self.status_id,
            is_default: self.is_default,
            send_completion_email: self.send_completion_email,
            questions: questions
          }
        }).then(() => {
          showSuccess(self.$t("general.successfully_updated"))
          this.$router.push({ name: "company.surveys.list" });
        });
      } else {
        // Create new survey
        store.dispatch(MODULE_NAME + "/" + CREATE_ITEM, {
          url: BASE_URL,
          contents: {
            name: self.name,
            status_id: self.status_id,
            is_compulsory: self.is_compulsory,
            send_completion_email: self.send_completion_email,
            point: self.point,
            questions: questions
          }
        }).then((response) => {
          showSuccess(self.$t("general.successfully_created"))

          if (process_type === 'assign_page') {
            this.$router.push({
              name: "company.assignments.add",
              params: { id: response.content_id, title: response.name, name: this.$t('general.survey') }
            });
          } else {
            this.$router.push({ name: "company.surveys.list" });
          }
        })
      }
    },
    addDropdownQuestion() {
      let question = {
        id: this.isEditMode ? 0 : undefined,
        name: null,
        type: 1,
        options: [
          {
            label: null,
            point: 1,
          },
          {
            label: null,
            point: 2,
          }
        ]
      };
      this.questions.push(question);
    },
    addTextareaQuestion() {
      let question = {
        id: this.isEditMode ? 0 : undefined,
        name: null,
        type: 2,
        options: []
      };

      this.questions.push(question);
    },
    addQuestion() {
      switch (this.selected_question_type) {
        case 1:
          this.addDropdownQuestion();
          break;
        case 2:
          this.addTextareaQuestion();
          break;
      }
    },
    deleteQuestion(index, id) {
      if (this.isEditMode && id > 0) {
        store.dispatch(MODULE_NAME + '/' + DELETE_QUESTION, {
          url: BASE_URL + '/delete-question/' + id
        });
      }
      this.questions.splice(index, 1);
    },
    getItem() {
      if (this.isEditMode) {
        store.dispatch(MODULE_NAME + '/' + GET_ITEM, {
          url: BASE_URL + '/' + this.$route.params.id,
        });
      }
    },
    resetMessages() {
      this.errorMessages = [];
    },
    scrollToTop() {
      window.scroll({
        top: 0,
        behavior: "smooth",
      });
    },
  },
  watch: {
    surveyItem: {
      handler(val) {
        if (val && this.isEditMode) {
          this.loadSurveyData();
        }
      },
      deep: true,
      immediate: true
    },
    error: function (val) {
      if (val) {
        this.scrollToTop();
        this.errorMessages.push(val);
      }
    },
    errorMessages() {
      if (this.debouncedResetValues) {
        this.debouncedResetValues();
      }
    },
  },
  mounted() {
    if (this.isEditMode) {
      this.getItem();
    } else {
      this.addDropdownQuestion();
    }
  },
  created: function () {
    this.debouncedResetValues = _.debounce(this.resetMessages, 5000);
  },
}
</script>

<style scoped>
.question-item {
  background: rgb(251, 251, 251);
  padding: 15px;
  margin-bottom: 15px;
  border: 1px solid #efefef;
}

.no-switcher {
  display: block !important;
}

.no-switcher > li {
  display: block !important;
}
</style>
